export { default as CompactDetails } from './CompactDetails';
